'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Selectors


// Components


// Actions


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _reselect = require('reselect');

var _boardSelector = require('../element/board/boardSelector');

var _Inbox = require('./Inbox');

var _Inbox2 = _interopRequireDefault(_Inbox);

var _InboxClosed = require('./InboxClosed');

var _InboxClosed2 = _interopRequireDefault(_InboxClosed);

var _inboxActions = require('./inboxActions');

var _selectionActions = require('../element/selection/selectionActions');

var _inboxConstants = require('./inboxConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Redux property connectors. */
var mapStateToProps = (0, _reselect.createSelector)(_boardSelector.getIsCurrentBoardFetched, _boardSelector.getCurrentBoardInboxState, function (isCurrentBoardFetched, currentBoardInboxState) {
    return {
        inboxState: isCurrentBoardFetched && currentBoardInboxState || _inboxConstants.INBOX_STATE.CLOSED
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        dispatchCloseInbox: function dispatchCloseInbox(id) {
            return dispatch((0, _inboxActions.closeInbox)({ id: id }));
        },
        dispatchOpenInbox: function dispatchOpenInbox(id) {
            return dispatch((0, _inboxActions.openInbox)({ id: id }));
        },
        deselectAll: function deselectAll(event) {
            return dispatch((0, _selectionActions.deselectAllElements)());
        }
    };
};

var InboxContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(InboxContainer, _React$Component);

    function InboxContainer(props) {
        _classCallCheck(this, InboxContainer);

        var _this = _possibleConstructorReturn(this, (InboxContainer.__proto__ || Object.getPrototypeOf(InboxContainer)).call(this, props));

        _this.openInbox = _this.openInbox.bind(_this);
        _this.closeInbox = _this.closeInbox.bind(_this);
        return _this;
    }

    _createClass(InboxContainer, [{
        key: 'openInbox',
        value: function openInbox() {
            this.props.dispatchOpenInbox(this.props.currentBoardId);
        }
    }, {
        key: 'closeInbox',
        value: function closeInbox() {
            this.props.dispatchCloseInbox(this.props.currentBoardId);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                inboxState = _props.inboxState,
                inboxElementIds = _props.inboxElementIds,
                gridSize = _props.gridSize,
                currentBoardId = _props.currentBoardId,
                deselectAll = _props.deselectAll,
                currentBoard = _props.currentBoard;


            return inboxState === _inboxConstants.INBOX_STATE.OPEN ? _react2.default.createElement(_Inbox2.default, _extends({ closeInboxHandler: this.closeInbox, gridSize: gridSize }, this.props, {
                inboxElementIds: inboxElementIds, currentBoardId: currentBoardId, deselectAll: deselectAll })) : _react2.default.createElement(_InboxClosed2.default, { openInboxHandler: this.openInbox, inboxElementIds: inboxElementIds, element: currentBoard });
        }
    }]);

    return InboxContainer;
}(_react2.default.Component)) || _class);


InboxContainer.propTypes = {
    currentBoard: _propTypes2.default.object.isRequired,
    inboxElementIds: _propTypes2.default.array.isRequired,
    currentBoardId: _propTypes2.default.string.isRequired,
    inboxState: _propTypes2.default.string,
    dispatchCloseInbox: _propTypes2.default.func,
    dispatchOpenInbox: _propTypes2.default.func,
    deselectAll: _propTypes2.default.func,
    gridSize: _propTypes2.default.number
};

exports.default = (0, _recompose.onlyUpdateForPropTypes)(InboxContainer);


//////////////////
// WEBPACK FOOTER
// ./src/client/inbox/InboxContainer.js
// module id = 2029
// module chunks = 0